(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_gco-custom-code"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = 'custom-gco-custom-code[data-gco-module-src]';

    const loadModule = (root) => {
      if (!(root instanceof Document || root instanceof Element)) return;

      const host = root.matches?.(selector) ? root : root.querySelector(selector);
      const moduleSource = host?.dataset.gcoModuleSrc;

      if (moduleSource) import(moduleSource);
    };

    loadModule(document);
    document.addEventListener('shopify:section:load', (event) => {
      loadModule(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sentinels = document.querySelectorAll('.product-grid-container [ref="viewMoreNext"]');

    sentinels.forEach((sentinel) => {
      const root = sentinel.closest('results-list');
      const grid = root ? root.querySelector('[ref="grid"]') : null;
      if (!grid) return;

      const hasMorePages = () => {
        const lastPage = Number(grid.dataset.lastPage || 1);
        const cards = grid.querySelectorAll('[ref="cards[]"]');
        const lastCard = cards[cards.length - 1];
        const currentPage = lastCard ? Number(lastCard.dataset.page || 1) : 1;
        return currentPage < lastPage;
      };

      const syncDone = () => {
        sentinel.classList.toggle('plp-loader--done', !hasMorePages());
      };
      syncDone();

      const intersectionObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && hasMorePages()) {
              sentinel.classList.add('plp-loader--active');
            }
          }
        },
        { rootMargin: '100px' }
      );
      intersectionObserver.observe(sentinel);

      const gridObserver = new MutationObserver(() => {
        sentinel.classList.remove('plp-loader--active');
        syncDone();
      });
      gridObserver.observe(grid, { childList: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
